module.exports = __webpack_public_path__ + "img/green-snowflake.def007b9.png";